/**
 * Created by admin on 2018/4/11.
 */
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Table } from 'antd';
import { ENGLISH, PARTICIPANT_STATUS } from '../utils/constants';

class RoomSelect extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedRowKeys: []
    };
  }

  componentDidMount() {
    const { defaultSelectedKeys } = this.props;
    this.setState({ selectedRowKeys: defaultSelectedKeys });
  }

  render() {
    const {
      onClose,
      onChange,
      participantList = [],
      intl
    } = this.props;
    const { selectedRowKeys } = this.state;

    const columns = [
      {
        title: intl.formatMessage({ id: 'mc_table_room' }),
        key: 'name',
        render: (text, record) => {
          const { name = '', nameEn = '' } = record;
          return intl.locale === ENGLISH ? nameEn : name;
        }
      },
      {
        title: intl.formatMessage({ id: 'mc_table_number' }),
        dataIndex: 'terminalAddress'
      }
    ];
    const data = [];
    participantList.forEach(p=>{
      if (p.removed === 0 && p.state === PARTICIPANT_STATUS.connected) {
        data.push({
          key: p.participantId,
          roomId: p.roomId,
          cmmaRoomId: p.cmmaRoomId,
          name: p.name,
          nameEn: p.nameEn,
          terminalAddress: p.address
        })
      }
    })

    return (
      <div className="rotation-container">
        <div className="content-wrap">
          <Table
            rowSelection={{
              fixed: true,
              selectedRowKeys,
              onChange: selectedRowKeys => {
                this.setState({ selectedRowKeys });
              }
            }}
            columns={columns}
            dataSource={data}
            pagination={false}
            bordered
            size="small"
          />
        </div>
        <div className="operate">
          <div
            className="btn"
            onClick={() => {
              onChange(selectedRowKeys);
              onClose();
            }}
          >
            <FormattedMessage id="mc_btn_ok" />
          </div>
          <div className="btn" onClick={onClose}>
            <FormattedMessage id="mc_btn_cancel" />
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(RoomSelect);



// WEBPACK FOOTER //
// ./src/components/RoomSelect.js